import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.overwatch');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);
const CANONICAL_ORIGIN = 'https://overwatch.river.seasonai.net';
const DIRECT_ENTRY_PATH = '/assets/overwatch/index.html';
const ASSET_VERSION = '202605081635';

@Component({
    selector: 'wiz-page-overwatch',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.overwatch/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageOverwatchComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.redirectToCanonical()) return;
        if (this.redirectToDirectEntry()) return;
        await this.service.render();
    }

    private redirectToCanonical() {
        const hostname = location.hostname.toLowerCase();
        if (!LOCAL_HOSTS.has(hostname)) return false;

        const target = new URL(`${location.pathname}${location.search}${location.hash}`, CANONICAL_ORIGIN);
        if (target.toString() === location.href) return false;

        location.replace(target.toString());
        return true;
    }

    private redirectToDirectEntry() {
        const current = new URL(location.href);
        const pathname = current.pathname.replace(/\/+$/, '') || '/';
        if (pathname !== '/') return false;

        const target = new URL(DIRECT_ENTRY_PATH, location.origin);
        current.searchParams.forEach((value, key) => {
            if (key !== 'v') target.searchParams.set(key, value);
        });
        target.searchParams.set('v', ASSET_VERSION);
        target.hash = current.hash;

        if (target.toString() === current.toString()) return false;

        location.replace(target.toString());
        return true;
    }
}

export default PageOverwatchComponent;